module.exports = __webpack_public_path__ + "img/symbol_3.b7ad2e83.png";